import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Header from "../home/Header";
import ByDate from "../dashboards/ByDate";
// import ByDevice from "../dashboards/ByDevice";
import BySource from "../dashboards/BySource";
import TableCell from "../home/TableCell";
import PageNotFound from "../home/PageNotFound";
import base from "../../helpers/filter-widget-base";
import apiHelper from "../../helpers/api";
import sort from "../../helpers/customSort";
import dashboardHeader from "../../config/dashboardHeader.json";
import "bootstrap/dist/js/bootstrap.js";
import "../../static/css/header.css";
import "../../static/css/home.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...base.filtersInitState(),
      ...base.widgetsInitState()
    };
  }

  /**
   * Update the state.
   *
   * @param {string} name The desired key to be updated.
   * @param {Object} component The object avlue which will replace the current object value in the desired key.
   */
  updateState = (name, component) => {
    this.setState({
      [name]: component
    });
  };

  /**
   * Create Columns for export CSV option.
   *
   * @return {Object} columns heading name.
   */
  createCsvColumns = (data, widgetName) => {
    let columns = [];
    if (data[0])
      columns = Object.values(dashboardHeader["Name"][widgetName]["show"]);
    return columns;
  };

  /**
   * Create Columns for Dashboard Table.
   *
   * @return {Object} to map to React Table.
   */
  createDisplayColumns = (data, widgetName, totalData) => {
    let columns = [];
    if (data[0]) {
      const keys = Object.keys(dashboardHeader["Name"][widgetName]["show"]);

      // console.log(keys, data, totalData, dashboardHeader["Name"]);
      keys.forEach((key, index) => {
        const column = {
          Header: dashboardHeader["Name"][widgetName]["show"][key],
          Footer:
            index === 0 ? (
              <>Total</>
            ) : totalData[0][key] === undefined ||
              totalData[0][key] === null ? (
              <>&mdash;</>
            ) : (
              totalData[0][key]
            ),
          accessor: key,
          headerClassName: "semi-bold dark-border",
          className: "dark-border",
          sortMethod: (a, b) => sort.DiffSort(a, b),
          Cell: row => TableCell(row)
        };
        columns.push(column);
      });
    }
    return columns;
  };

  /**
   * Intiliaze widgets Columns for React Table and export CSV option.
   */
  initWidgetsColumns = (widget, widgetName, data, totalData) => {
    widget.columns = this.createDisplayColumns(data, widgetName, totalData);
    widget.csv_columns = this.createCsvColumns(data, widgetName);
    return widget;
  };

  /**
   * Get Dashboard Data to populate table fields.
   *
   * @param {Object} object The object contains widgetName, shoudMetricUpdate to check if submit is clicked, shouldColumnUpdate to check if metrics are present as rows or columns.
   */
  getWidgetsData = object => {
    const { widgetName, widget } = object;
    apiHelper
      .getData(
        widget["type"],
        this.props.token,
        this.state["Time Period"].startDate,
        this.state["Time Period"].endDate
      )
      .then(response => {
        // console.log(response);
        const responseData = response.data;
        const statusCode = response.status;
        if (responseData.status === "success") {
          let filteredData = [];
          let totalData = [];
          if (responseData.data[0]) {
            filteredData = [...responseData.data[0]];
          }
          if (responseData.data[1]) {
            totalData = [...responseData.data[1]];
          }
          let newWidget = this.initWidgetsColumns(
            widget,
            widgetName,
            filteredData,
            totalData
          );
          newWidget["data"] = filteredData;
          const keys = Object.keys(dashboardHeader["Name"][widgetName]["show"]);
          let csvData = [...filteredData, ...totalData];
          let formattedCsvData = [];
          formattedCsvData = csvData.map(data => {
            let formattedObject = {};
            keys.forEach(key => {
              formattedObject[
                dashboardHeader["Name"][widgetName]["show"][key]
              ] = data[key];
            });
            return formattedObject;
          });
          newWidget.csv_data = formattedCsvData;
          this.updateState(widgetName, newWidget);
        } else {
          if (statusCode === 401) {
            this.props.unAuthUser();
          } else {
            let message = "";
            for (let key in responseData["error"]) {
              if (responseData["error"].hasOwnProperty(key)) {
                message += responseData["error"][key][0];
              }
            }
            this.props.showAlert("danger", message);
          }
        }
      })
      .catch(error => {
        // console.log(error);
        this.props.showAlert("danger", "Something went wrong!");
      });
  };

  render() {
    const filters = {
      "Time Period": { ...this.state["Time Period"] }
    };

    return (
      <div className="home-wrpr">
        {this.props.alertBox}
        <div className="clearfix">
          <Header
            username={this.props.username}
            setAuthorizedStatus={() => this.props.setAuthorizedStatus()}
            showAlert={(type, message, timeout) =>
              this.props.showAlert(type, message, timeout)
            }
            setAlertNull={this.setAlertNull}
            logoutUser={this.props.logoutUser}
          />
          <Switch>
            <Route exact path="/(date|/|)/">
              <ByDate
                widgetName="Date"
                widgets={this.state["Date"]}
                filters={filters}
                updateState={(name, component) =>
                  this.updateState(name, component)
                }
                setAlertNull={this.props.setAlertNull}
                getWidgetsData={object => this.getWidgetsData(object)}
              />
            </Route>
            <Route  exact path="/device" >
                  <Redirect to="/date" />
            </Route>
            
            {/* <Route exact path="/device">
              <ByDevice
                widgetName="Device"
                widgets={this.state["Device"]}
                filters={filters}
                updateState={(name, component) =>
                  this.updateState(name, component)
                }
                setAlertNull={this.props.setAlertNull}
                getWidgetsData={object => this.getWidgetsData(object)}
              />
            </Route> */}
            <Route exact path="/source">
              <BySource
                widgetName="Source"
                widgets={this.state["Source"]}
                filters={filters}
                updateState={(name, component) =>
                  this.updateState(name, component)
                }
                setAlertNull={this.props.setAlertNull}
                getWidgetsData={object => this.getWidgetsData(object)}
              />
            </Route>
            <Route
              component={() => (
                <PageNotFound
                  showAlert={(type, message, timeout) =>
                    this.props.showAlert(type, message, timeout)
                  }
                />
              )}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Home;
